import { render } from "./wokerDetail7.vue?vue&type=template&id=27ec5ad0&scoped=true"
import script from "./wokerDetail7.vue?vue&type=script&lang=js"
export * from "./wokerDetail7.vue?vue&type=script&lang=js"

import "./wokerDetail7.vue?vue&type=style&index=0&id=27ec5ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ec5ad0"]])

export default __exports__